
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';
import { Ledger } from '../models/ledger';

let AppConstant: any = {};
@Injectable()
export class LedgerService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    get() {
        return this.http.get(`setups/account-type`).pipe(
            map((res:any) =>  res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllAccountCategories() {
        return this.http.get(`setups/account-category`).pipe(
            map((res:any) =>  res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    save(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/account-type`, bodyObj).pipe(
            map((res:any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

}